import { takeLatest, select, cancel, put } from 'redux-saga/effects';
import size from 'lodash/size';
import * as unresolved from '../complaintUnResolvedList';
import * as resolved from '../complaintResolvedList';
import {
  makeSelectComplaintsCounter,
  selectResolvedList,
  selectResolvedListPagination,
  selectUnResolvedList,
  selectUnresolvedListPagination,
} from '../selectors';

function* loadMoreUnresolvedComplaints() {
  const counter = yield select(makeSelectComplaintsCounter('unresolved'));
  const currentList = yield select(selectUnResolvedList);
  const pagination = yield select(selectUnresolvedListPagination);
  const listSize = size(currentList);

  if (counter <= listSize) {
    yield cancel();
  }

  yield put(
    unresolved.paginationActions.send({
      ...pagination,
      offset: listSize,
      status: 'unresolved',
    }),
  );
}
function* loadMoreResolvedComplaints() {
  const counter = yield select(makeSelectComplaintsCounter('resolved'));
  const currentList = yield select(selectResolvedList);
  const pagination = yield select(selectResolvedListPagination);
  const listSize = size(currentList);

  if (counter <= listSize) {
    yield cancel();
  }

  yield put(
    resolved.paginationActions.send({
      ...pagination,
      offset: listSize,
      status: 'resolved',
    }),
  );
}

export default function* complaintListPagination() {
  yield takeLatest([unresolved.consts.LOAD_MORE], loadMoreUnresolvedComplaints);
  yield takeLatest([resolved.consts.LOAD_MORE], loadMoreResolvedComplaints);
}



// WEBPACK FOOTER //
// ./src/redux/complaints/watchers/complaintListPagination.js